import Api_Usermanagement from '../api-usermanagement'

const api = new Api_Usermanagement().init()

const getLetter = (sales, module, create, update, lang) => {
  return api.get(
    `/config/letter?credentials=${localStorage.getItem(
      'credential'
    )}&sales_org_code=${sales}&module=${module}&created_at=${create}&updated_at=${update}&lang=${lang}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getLetterDetail = (id) => {
  return api.get(`/config/letter/${id}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getLetterForModule = ({sales_org, module}) => {
  return api.get(`/config/letter/get?sales_org_code=${sales_org}&module=${module}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const createLetter = (data) => {
  return api.post(`/config/letter/create?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const createOptionalText = (data) => {
  return api.post(`/config/additional-text/create?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const updateLetter = (id, data) => {
  return api.post(
    `/config/letter/edit/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const updateOptionalText = (id, data) => {
  return api.post(
    `/config/additional-text/edit/${id}?credentials=${localStorage.getItem('credential')}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const deleteLetter = (id) => {
  return api.delete(`/config/letter/${id}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const deleteOptionalText = (id) => {
  return api.delete(`/config/additional-text/${id}?credentials=${localStorage.getItem('credential')}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {getLetter, getLetterDetail, createLetter, createOptionalText, updateLetter, updateOptionalText, deleteLetter, deleteOptionalText, getLetterForModule}
